// extracted by mini-css-extract-plugin
export default {"txt-status":"status-fatura_txt-status__ya8Q9"};